import { AppModule } from '@/store/modules/app';

// New Talentspace UI strings that have no translation id yet. Once an id exists, use
// AppModule.translation[id] and drop the entry here.
const texts = {
  de: {
    backToProfile: 'Zurück zum Profil',
    contactDetailsTitle: 'Ihre Kontaktdaten',
    requiredFieldsNote: '* Pflichtfelder',
  },
  en: {
    backToProfile: 'Back to profile',
    contactDetailsTitle: 'Your contact details',
    requiredFieldsNote: '* Required fields',
  },
  uk: {
    backToProfile: 'Назад до профілю',
    contactDetailsTitle: 'Ваші контактні дані',
    requiredFieldsNote: '* Обовʼязкові поля',
  },
};

export type TalentspaceTextKey = keyof typeof texts.de;

// Falls back to German, the portal's main language
export const tsText = (key: TalentspaceTextKey): string => {
  const lang = AppModule.language as keyof typeof texts;
  return (texts[lang] || texts.de)[key];
};
